import { render } from "./InboundTemplateSourcesList.vue?vue&type=template&id=9ecb023c&scoped=true&ts=true"
import script from "./InboundTemplateSourcesList.vue?vue&type=script&lang=ts"
export * from "./InboundTemplateSourcesList.vue?vue&type=script&lang=ts"

import "./InboundTemplateSourcesList.vue?vue&type=style&index=0&id=9ecb023c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ecb023c"],['__file',"src/app/catalog/mapping-template/inbound/InboundTemplateSourcesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ecb023c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ecb023c', __exports__)) {
    api.reload('9ecb023c', __exports__)
  }
  
  module.hot.accept("./InboundTemplateSourcesList.vue?vue&type=template&id=9ecb023c&scoped=true&ts=true", () => {
    api.rerender('9ecb023c', render)
  })

}


export default __exports__